import React, { useLayoutEffect, useState } from 'react';
import { truncate } from 'lodash';

import SectionedBarGroups from '@test_prep/app/pages/analytics/components/sectioned_bar_groups';
import StatisticData from '@test_prep/app/pages/analytics/components/statistic_data';

import loadingData from './loading_data';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  examName: string;
  sections: string;
  filters: any;
}

const PerformanceByTypeChart: React.FC<Props> = (props) => {

  const loadingPlaceholder = (
    <SectionedBarGroups
      colorPalette={{ dark: colors.gray85, light: colors.grayLightest }}
      data={loadingData(props.examName, props.filters.sections)}
    />
  );

  const formatStatisticData = (statisticData) => {
    return statisticData.map((group) => {
      const data = group.data.map((dataPoints) => {
        return {
          ...dataPoints,
          label: truncate(dataPoints.label, { length: 20 })
        };
      });

      return {
        name: group.name,
        data
      };
    });
  };

  if (!props.filters) {
    return loadingPlaceholder;
  } else {
    return (
      <StatisticData
        filters={props.filters}
        formatDataFn={formatStatisticData}
        name="performance_by_type"
      >
        <StatisticData.Loading>
          {loadingPlaceholder}
        </StatisticData.Loading>

        {/* @ts-ignore */}
        <SectionedBarGroups
          colorPalette={{ dark: colors.dataDarkPurple, light: colors.dataMutedPurple }}
        />
      </StatisticData>
    );
  }
};

export default PerformanceByTypeChart;
